import React from 'react';
import DoNotDisturbAltOutlinedIcon from '@mui/icons-material/DoNotDisturbAltOutlined';
import { useTranslation } from 'react-i18next';

import scss from './UsedMediaDeletedCard.module.scss';

function UsedMediaDeletedCard() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.card} role='img' aria-label={t('mediaDeleted')}>
      <DoNotDisturbAltOutlinedIcon className={scss.icon} aria-hidden='true' />
      <span className={scss.label}>{t('mediaDeleted')}</span>
    </div>
  );
}

export default UsedMediaDeletedCard;
